import _ from 'lodash';
import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { TextField } from 'rmwc';
import '../libraries';

import Tree from '../components/tree';
import Dialog from '../dialog/dialog';
import * as styles from '../styles';
import { request, login } from './actions';
import { close, setErrors } from '../dialog/actions';

var gettext = window.gettext;

const nameValidator = /^[ا-ی ‌ئؤآأ]{2,255}$/;
const namePartialValidator = nameValidator.toPartialMatchRegex();
const passwordValidator = /^.{8,255}$/;
const passwordPartialValidator = passwordValidator.toPartialMatchRegex();
const cellphoneValidator = /^[0۰][9۹][\d۰-۹]{9}$/;
const cellphonePartialValidator = cellphoneValidator.toPartialMatchRegex();
const emailValidator = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const emailPartialValidator = emailValidator.toPartialMatchRegex();



// //@Radium
export default class RegistrationDialog extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    };

    state = {
        firstname: '',
        lastname: '',
        cellphone: '',
        email: '',
        password: '',
        confirmPassword: '',
        gender: null,
        firstnameValidator: nameValidator,
        lastnameValidator: nameValidator,
        cellphoneValidator,
        emailValidator,
        passwordValidator,
        openGenderBox: false,
        genderError: false
    };

    renderBody() {
        return <div style={styles.registerDialog}>
            <form
                ref='form'
                style={{ marginBottom: 0 }}
                onSubmit={async event => {
                    event.preventDefault();
                    const validFirstname = (
                        this.state.firstname !== '' ||
                        !(
                            this.props.errors.firstname ||
                            !this.state.firstname.match(nameValidator)
                        )
                    );
                    const validLastname = (
                        this.state.lastname !== '' ||
                        !(
                            this.props.errors.lastname ||
                            !this.state.lastname.match(nameValidator)
                        )
                    );
                    const validPassword = (
                        this.state.password !== '' ||
                        !(
                            this.props.errors.password ||
                            !this.state.password.match(passwordValidator)
                        )
                    );
                    const validCellphone = (
                        this.state.cellphone !== '' ||
                        !(
                            this.props.errors.cellphone ||
                            !this.state.cellphone.match(cellphoneValidator)
                        )
                    );
                    const validEmail = (
                        this.state.email === '' ||
                        !(
                            this.props.errors.email ||
                            !this.state.email.match(emailValidator)
                        )
                    );
                    const validgender = (
                        this.state.gender !== '' ||
                        !(
                            this.props.errors.cellphone ||
                            !this.state.cellphone.match(cellphoneValidator)
                        )
                    );
                    const password = this.state.password;
                    const level = this.props.extra.getIn(['levelsTree', 'selected']).keySeq().first();
                    const grade = this.props.extra.getIn(['gradesTree', 'selected']).keySeq().first();

                    if(!validFirstname || !validLastname || !validCellphone || !validEmail || !validPassword)
                        return
                    if (grade === undefined || grade === '' || grade === null) {
                        this.context.store.dispatch(setErrors({
                            grade: ['لطفا پایه خود را وارد کنید'],
                        }, this.props.elementId));
                        return;
                    }

                    if (password !== this.state.confirmPassword) {
                        this.context.store.dispatch(setErrors({
                            confirm_password: [window.gettext('Passwords mismatch')],
                        }, this.props.elementId));
                        return;
                    }
                    if (!this.state.gender) {
                        return this.setState({ genderError: true })
                    }
                    else if (this.state.gender == 1 || this.state.gender == 2) {
                        this.setState({ genderError: false })
                    }
                    try {
                        await this.context.store.dispatch(request(
                            '/user/',
                            {
                                method: 'POST',
                                body: {
                                    firstname: this.state.firstname,
                                    lastname: this.state.lastname,
                                    username: this.state.cellphone,
                                    email: this.state.email,
                                    cell_phone: this.state.cellphone,
                                    password: this.state.password,
                                    gender: this.state.gender,
                                    ...this.props.extra.getIn(['gradesTree', 'selected']).size
                                        ? { grade: { id: this.props.extra.getIn(['gradesTree', 'selected']).keySeq().first() } }
                                        : {},
                                },
                            },
                        ));
                        this.context.store.dispatch(setErrors({}, this.props.elementId));
                        await this.context.store.dispatch(login(
                            this.state.cellphone,
                            this.state.password,
                        ));
                        this.refs.form.reset();
                        this.context.store.dispatch(close(this.props.elementId));
                    }
                    catch (error) {
                        this.context.store.dispatch(setErrors(error, this.props.elementId));
                    }
                }}>
                {/* first name */}
                <div style={styles.registerRightDialogField}>
                    <TextField
                        ref='firstname'
                        rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                        pattern={this.state.firstnameValidator.source}
                        required
                        outlined
                        autoCorrect='off'
                        autoCapitalize='none'
                        label={window.gettext('firstname')}
                        value={this.state.firstname}
                        onChange={({ target: { value } }) => {
                            if (value.length > 0 && !value.match(namePartialValidator))
                                return;
                            this.setState({ firstname: value });
                        }}
                        onFocus={() => this.setState({ firstnameValidator: namePartialValidator })}
                        onBlur={() => this.setState({ firstnameValidator: nameValidator })}
                    />
                    <div style={styles.error}>
                        {this.props.errors.firstname
                            ? _.map(
                                this.props.errors.firstname,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : null
                        }
                    </div>
                </div>
                {/* last name */}
                <div style={styles.registerLeftDialogField}>
                    <TextField
                        ref='lastname'
                        rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                        pattern={this.state.lastnameValidator.source}
                        required
                        outlined
                        autoCorrect='off'
                        autoCapitalize='none'
                        label={window.gettext('lastname')}
                        value={this.state.lastname}
                        onChange={({ target: { value } }) => {
                            if (value.length > 0 && !value.match(namePartialValidator))
                                return;
                            this.setState({ lastname: value });
                        }}
                        onFocus={() => this.setState({ lastnameValidator: namePartialValidator })}
                        onBlur={() => this.setState({ lastnameValidator: nameValidator })}
                    />
                    <div style={styles.error}>
                        {this.props.errors.lastname
                            ? _.map(
                                this.props.errors.lastname,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : null
                        }
                    </div>
                </div>
                {/* phone */}
                <div style={styles.registerRightDialogField}>
                    <TextField
                        ref='cellphone'
                        style={{ direction: 'ltr' }}
                        rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                        pattern={this.state.cellphoneValidator.source}
                        required
                        outlined
                        autoCorrect='off'
                        autoCapitalize='none'
                        label={window.gettext('cellphone')}
                        value={this.state.cellphone.persian()}
                        onChange={({ target: { value } }) => {
                            value = value.english();
                            if (value.length > 0 && !value.match(cellphonePartialValidator))
                                return;
                            this.setState({ cellphone: value });
                        }}
                        onFocus={() => this.setState({ cellphoneValidator: cellphonePartialValidator })}
                        onBlur={() => this.setState({ cellphoneValidator })}
                    />
                    <div style={styles.error}>
                        {this.props.errors.username
                            ? _.map(
                                this.props.errors.username,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : this.props.errors.cell_phone
                                ? _.map(
                                    this.props.errors.cell_phone,
                                    (error, index) => <li style={{ display: 'block' }} key={index}>
                                        * {error}
                                    </li>,
                                )
                                : null
                        }
                    </div>
                </div>
                {/* gender */}
                <div style={styles.registerRightDialogField}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        boxShadow: " rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
                        fontSize: "0.95em",
                        backgroundColor: "#fff",
                        color: "black",
                        padding: "12px",
                        color: "rgba(0, 0, 0, 0.6)",
                        height: "unset",
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: "3px"
                    }}
                    >
                        <span style={{ width: "100%", height: "100%", display: "block",cursor:"pointer" ,color: `${(this.state.gender == 2 || this.state.gender == 1) ? "#000" : "rgba(0,0,0,0.6"}` }} onClick={() => {
                            this.setState({ openGenderBox: !this.state.openGenderBox });
                        }}>
                            {this.state.gender == 1 ? "مرد" : this.state.gender == 2 ? "زن" : "جنسیت"}
                        </span>
                        <span
                            style={{ cursor: "pointer", color: "rgba(100,100,100,0.7)", fontSize: "1.2em" }}
                            onClick={() => {
                                this.setState({ openGenderBox: !this.state.openGenderBox });
                            }}
                        >
                            <i className="fa-chevron-down"></i>
                        </span>

                    </div>
                    <div style={{ position: "relative",boxShadow: " rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px", zIndex: "100000", height: "76px", display: `${this.state.openGenderBox ? "block" : "none"}`, backgroundColor: "#fff", border: "1px solid  rgba(0, 0, 0, 0.12)", borderTop: "none", borderRadius: "3px" }}>
                        <div style={{ display: "flex", position: "absolute", top: "-3px", left: "0", width: "100%", flexDirection: "column", }}>
                            <div onClick={(e) => { this.setState({ gender: e.target.attributes["value"].value, openGenderBox: false, genderError: false }) }} style={{ width: "100%", fontSize: "0.95em", color: "#000", padding: "0.25em 0.4em",cursor:"pointer" , boxSizing: "border-box", minHeight: "2.5em" }} value="1">
                                مرد
                            </div>
                            <div onClick={(e) => { this.setState({ gender: e.target.attributes["value"].value, openGenderBox: false, genderError: false }) }} style={{ width: "100%", fontSize: "0.95em", color: "#000", padding: "0.25em 0.4em",cursor:"pointer", boxSizing: "border-box", minHeight: "2.5em" }} value="2">
                                زن
                            </div>
                        </div>
                    </div>
                    {this.state.genderError ? <span style={{ color: "RGB(255,64,129)", fontSize: "0.8em" }}
                    >
                    *
                    {" "}
                    لطفا جنسیت را انتخاب نمایید  
                    </span> : null}
                </div>

                {/*---------------------*/}
                <div style={styles.registerLeftDialogField}>
                    <TextField
                        ref='email'
                        style={{ direction: 'ltr' }}
                        rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                        pattern={this.state.emailValidator.source}
                        outlined
                        autoCorrect='off'
                        autoCapitalize='none'
                        label={window.gettext('email')}
                        value={this.state.email}
                        onChange={({ target: { value } }) => {
                            value = value.english();
                            if (value.length > 0 && !value.match(emailPartialValidator))
                                return;
                            this.setState({ email: value });
                        }}
                        onFocus={() => this.setState({ emailValidator: emailPartialValidator })}
                        onBlur={() => this.setState({ emailValidator })}
                    />
                    <div style={styles.error}>
                        {this.props.errors.email
                            ? _.map(
                                this.props.errors.email,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : null
                        }
                    </div>
                </div>
                <div style={styles.registerRightDialogField}>
                    <TextField
                        ref='password'
                        style={{ direction: 'ltr' }}
                        rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                        pattern={this.state.passwordValidator.source}
                        required
                        outlined
                        autoCorrect='off'
                        autoCapitalize='none'
                        type='password'
                        label={window.gettext('password')}
                        value={this.state.password}
                        onChange={({ target: { value } }) => {
                            value = value.english();
                            if (value.length > 0 && !value.match(passwordPartialValidator))
                                return;
                            this.setState({ password: value });
                        }}
                        onFocus={() => this.setState({ passwordValidator: passwordPartialValidator })}
                        onBlur={() => this.setState({ passwordValidator })}
                    />
                    <div style={styles.error}>
                        {this.props.errors.password
                            ? _.map(
                                this.props.errors.password,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : null
                        }
                    </div>
                </div>
                <div style={styles.registerLeftDialogField}>
                    <TextField
                        ref='confirm_password'
                        style={{ direction: 'ltr' }}
                        rootProps={{ style: { width: '100%', lineHeight: '1.2em' } }}
                        pattern={'^$|' + this.state.password}
                        required
                        outlined
                        autoCorrect='off'
                        autoCapitalize='none'
                        type='password'
                        label={window.gettext('confirm password')}
                        value={this.state.confirmPassword}
                        onChange={({ target: { value } }) => this.setState({ confirmPassword: value.english() })}
                    />
                    <div style={styles.error}>
                        {this.props.errors.confirm_password
                            ? _.map(
                                this.props.errors.confirm_password,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : null
                        }
                    </div>
                </div>
                <div style={{ ...styles.registerRightDialogField, marginTop: '1em', marginBottom: '.5em' }}>
                    <Tree
                        store={this.props.extra.get('levelsTree')}
                        readonly
                        resource='level'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Level')}
                    />
                </div>
                <div style={{ ...styles.registerLeftDialogField, marginTop: '1em', marginBottom: '.5em' }}>
                    <Tree
                        store={this.props.extra.get('gradesTree')}
                        readonly
                        required
                        resource='grade'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Grade')}
                        filter={{ level: this.props.extra.getIn(['levelsTree', 'selected']).keySeq().first() }}
                    />
                    <br />
                    <div style={styles.error}>
                        {this.props.errors.grade
                            ? _.map(
                                this.props.errors.grade,
                                (error, index) => <li style={{ display: 'block' }} key={index}>
                                    * {error}
                                </li>,
                            )
                            : null
                        }
                    </div>
                </div>
                <div style={styles.dialogButtonContainer}>
                    {this.props.pending > 0
                        ? <i className='fa-spin fa-spinner fa-2x'></i>
                        : <input
                            key='submit'
                            type='submit'
                            style={styles.defaultDialogButton}
                            value={window.gettext('register')}
                        />
                    }
                </div>
                <div style={{ clear: 'both' }}>
                    {window.gettext('Your username is your cell phone number.')}
                </div>
            </form>
        </div>;
    }


    render() {
        return <Dialog {...this.props}>
            {this.renderBody.bind(this)()}
            <span>
                <i className='fa-user-plus fa-3x'></i>
                <br />
                {window.gettext('register account')}
            </span>
        </Dialog>;
    }
};

//Radium(RegistrationDialog);
